import { url } from "./url_config";

export async function getDeviceList(id, token, limit, offset, filter) {
    try {
        const response = await fetch(`${url}devices?id=${id}&limit=${limit}&offset=${offset}&getConsumption=false&filter=${filter}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if(!response.ok) {
            return { error: true, status_code: response.status };
        }


        const data = await response.json();

        if (data.error === true) {
            return { error: true, message: data.message || "API error" };
        }

        return { error: false, data: data.body};

    } catch (e) {
        console.error("getDeviceList error:", e);
        return null;
    }
}